import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { FolderEmptyItem } from "src/components/Folders/FolderEmptyItem";
import { FolderItemsSection } from "src/components/Folders/FolderItemsSection";
import { FolderSelectionCheckbox } from "src/components/Folders/FolderSelectionCheckbox";
import type { FolderPreviewProps } from "src/components/Folders/types";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import { UserDeckCard } from "src/components/NewComponents/Flashcards/UserDecks/UserDeckCard";
import type { SearchDeck } from "src/hooks/useFlashcards";

export const FolderFlashcardsPreview = ({
	folderId,
	folderName,
	items,
	isSelectMode,
	selectedItems,
	toggleSelection,
}: FolderPreviewProps) => {
	const { t } = useTranslation();
	const { openModal } = useModals();

	return (
		<FolderItemsSection
			title={t("folder.tabs.flashcards", "Fiszki")}
			type="deck"
			folderId={folderId}
			isVisible={true}
		>
			{items?.map((item) => {
				const isSelected =
					isSelectMode &&
					selectedItems?.some(
						(i) => i.itemId === item.data?.id && i.itemType === "deck",
					);

				return (
					<div
						key={item.id}
						data-test-id="folder-deck-item"
						data-deck-id={item.data?.id}
						onClick={
							isSelectMode
								? () => toggleSelection(item.data, "deck", item.id)
								: undefined
						}
						className={cx("h-100", isSelectMode && "cursor-pointer p-relative")}
					>
						{isSelectMode && (
							<FolderSelectionCheckbox isSelected={!!isSelected} />
						)}
						<UserDeckCard
							deck={item.data as unknown as SearchDeck}
							className={cx(
								"mb-0 w-100 min-w-350 folder-deck-card h-100",
								isSelected && "border-color-primary",
								isSelectMode && "pointer-events-none",
							)}
						/>
					</div>
				);
			})}
			{(items?.length ?? 0) < 3 && (
				<FolderEmptyItem
					className="h-100-important"
					onClick={() => {
						openModal(ModalsNames.AddFolderContentModal, {
							folderId,
							folderName,
							initialTab: "deck",
						});
					}}
				/>
			)}
		</FolderItemsSection>
	);
};
